import { useCallback, useMemo } from 'react';
import { Drawer } from '@aimsos/ui';
import { getShellMainContentEl } from '../../../../shared/utils/shellPortal.js';
import ToolConfigureFormPanel from './ToolConfigureFormPanel.jsx';

const ToolConfigurationSlideout = ({ t, open, onClose, tool, onSave }) => {
  const drawerPortalTarget = useMemo(
    () => (open ? getShellMainContentEl() : null),
    [open],
  );

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  const handleSave = useCallback(
    (formData) => {
      onSave?.(formData);
    },
    [onSave],
  );

  if (!tool) return null;

  const title = tool.title || tool.name || t('edit.tools.tool');

  return (
    <Drawer
      isOpen={open}
      onClose={handleClose}
      portalTarget={drawerPortalTarget ?? undefined}
      widthClassName="w-[480px] shrink-0"
      panelClassName="min-w-0"
      ariaLabel={t('edit.tools.configureTitle', { title })}
    >
      <div className="flex h-full min-h-0 flex-col bg-surface p-6">
        <ToolConfigureFormPanel t={t} tool={tool} onSave={handleSave} showBackButton={false} />
      </div>
    </Drawer>
  );
};

export default ToolConfigurationSlideout;
